import { Injectable } from '@angular/core';

@Injectable()
export class SolidMultiTenancyService {

    get isEnabled(): boolean {
        return solid.multiTenancy.isEnabled;
    }

}